import PropTypes from 'prop-types';
import React from 'react';
import {programBannerTextColor} from '../helpers';


export default class ProgramBanner extends React.Component{
  state = {};


  render(){
    if(!this.props.program) return null;

    const backgroundColor = this.props.program.color || this.props.program.Color;

    return (
      <div className={`program-banner ${this.props.className || ''}`} style={{backgroundColor}}>
        <div className="program-banner__title" style={{color: programBannerTextColor(this.props.program)}}>
          {this.props.program.title || this.props.program.Title}
        </div>
      </div>
    );
  }
}


ProgramBanner.propTypes = {
  className: PropTypes.string,
  program: PropTypes.object,
};
